import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import account from './modules/account'
import user from './modules/user'
import crew from './modules/crew'
import workOrder from './modules/workOrder'
import workOrderTask from './modules/workOrderTask'
import schedule from './modules/schedule'
import region from './modules/region'
import documentType from './modules/documentType'
import document from './modules/document'
import image from './modules/image'
import role from './modules/role'
import checklist from './modules/checklist'
import changeOrder from './modules/changeOrder'
import changeOrderDocument from './modules/changeOrderDocument'
import file from './modules/file'
import loadingIndicator from './modules/loadingIndicator'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    account,
    checklist,
    role,
    user,
    crew,
    schedule,
    workOrderTask,
    workOrder,
    region,
    documentType,
    document,
    image,
    changeOrder,
    changeOrderDocument,
    file,
    loadingIndicator
  },
  plugins: [createPersistedState()]
})

export default store
